import actionCreators from "./actionCreators";

export default (state = { title: null, isLoading: true }, { type, payload }) => {
    switch (type) {
        case actionCreators.setTitle.type:
            return {
                ...state,
                title: payload,
            };
        case actionCreators.clearTitle.type:
            return {
                ...state,
                title: null,
            };
        case actionCreators.setLoading.type:
            return {
                ...state,
                isLoading: true,
            };
        case actionCreators.clearLoading.type:
            return {
                ...state,
                isLoading: false,
            };
        case actionCreators.errorResponse.type:
            return {
                ...state,
                errorRes: payload,
            };
        default:
            return state;
    }
};
